import { gql } from "@apollo/client";

export const GET_CUSTOMER_LOCATIONS = gql`
  query GetCustomerLocations {
    customerLocations {
      id
      location
    }
  }
`;

export const GET_SERVICE_LOCATIONS = gql`
  query GetServiceLocations {
    serviceLocations {
      id
      location
      is_active
    }
  }
`;

export const GET_LOCKER_LOCATIONS = gql`
  query GetLockerLocations {
    lockerLocations {
      id
      location
      is_active
    }
  }
`;